// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Suppliers
export const getRepairActsList = createAsyncThunk('appRepairActs/getRepairActsList', async params => {
    /*
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getRepairActs'), params)        
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }*/
    params.page = params.page === 0 ? 0 : params.page - 1
    const response = await axios.post(`https://api.mfauto.com.ua/repair/act-list?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...params,
        token: localStorage.getItem('token')
    })
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addRepairAct = createAsyncThunk('appRepairActs/addRepairAct', async (data) => {
    const response = await axios.post(apiLink('addRepairAct'), data)
    return response.data
})
export const updateRepairAct = createAsyncThunk('appRepairActs/updateRepairAct', async (data) => {
    const response = await axios.put(apiLink({name: 'updateRepairAct', value: data.id}), data)
    return response.data
})
export const getRepairAct = createAsyncThunk('appRepairActs/getRepairAct', async (id) => {
    const response = await axios.get(apiLink({name: 'getRepairAct', value: id}))
    return response.data
})
export const removeRepairAct = createAsyncThunk('appRepairActs/removeRepairAct', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeRepairAct', value: id}))
    return response.data
})

export const addRepairActService = createAsyncThunk('appRepairActs/addRepairActService', async (data) => {    
    const id = data.repair_act_id
    delete data.repair_act_id
    const response = await axios.post(apiLink({name: 'addRepairActService', value: id}), data)
    return response.data
})
export const addRepairActProduct = createAsyncThunk('appRepairActs/addRepairActProduct', async (data) => {    
    const id = data.repair_act_id
    delete data.repair_act_id
    const response = await axios.post(apiLink({name: 'addRepairActProduct', value: id}), data)
    return response.data
})
export const confirmRepairActProduct = createAsyncThunk('appRepairActs/confirmRepairActProduct', async (id) => {        
    const response = await axios.post(apiLink('confirmRepairActProduct', {reservation_id: id}))
    return response.data
})
export const confirmAllRepairActProduct = createAsyncThunk('appRepairActs/confirmAllRepairActProduct', async (id) => {        
    const response = await axios.post(apiLink({name: 'confirmAllRepairActProduct', value: id}))
    return response.data
})
export const removeRepairActService = createAsyncThunk('appRepairActs/removeRepairActService', async id => {
    const response = await axios.delete(apiLink({name: 'removeRepairActService', value: id}))
    return response
})
export const removeRepairActProduct = createAsyncThunk('appRepairActs/removeRepairActProduct', async id => {
    const response = await axios.delete(apiLink('removeRepairActProduct', {reservation_id: id}))
    return response
})
export const completeRepairAct = createAsyncThunk('appRepairActs/completeRepairAct', async (id) => {        
    const response = await axios.post(apiLink({name: 'completeRepairAct', value: id}))
    return response
})
export const updateRepairActService = createAsyncThunk('appRepairActs/updateRepairActService', async (data) => {
    const response = await axios.put(apiLink({name: 'updateRepairActService', value: data.id}), data)
    return response.data
})
export const addRepairActRequestedProduct = createAsyncThunk('appRepairActs/addRepairActRequestedProduct', async (data) => {    
    const id = data.repair_act_id
    delete data.repair_act_id
    const response = await axios.post(apiLink({name: 'addRepairActRequestedProduct', value: id}), [data])
    return response.data
})
export const updateRepairActRequestedProduct = createAsyncThunk('appRepairActs/updateRepairActRequestedProduct', async (data) => {
    const response = await axios.put(apiLink({name: 'updateRepairActRequestedProduct', value: data.id}), data)
    return response.data
})
export const removeRepairActRequestedProduct = createAsyncThunk('appRepairActs/removeRepairActRequestedProduct', async id => {
    const response = await axios.delete(apiLink({name: 'removeRepairActRequestedProduct', value: id}))
    return response
})
export const removeRepairActStockProductItem = createAsyncThunk('appRepairActs/removeRepairActStockProductItem', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/act-remove-stock-item?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response
})
export const removeRepairActAPI = createAsyncThunk('appRepairActs/removeRepairActAPI', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/act-remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response
})

// ** Payments
export const addRepairActPayment = createAsyncThunk('appRepairActs/addRepairActPayment', async (data) => {
    return await axios.post(apiLink('addPayment'), data)
})
export const removeRepairActPayment = createAsyncThunk('appRepairActs/removeRepairActPayment', async (id) => {
    const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'SERVICE_STATION_REPAIR_ACT'}))
    return response.data
})

// **
export const getNextRepairActNumber = createAsyncThunk('appRepairActs/getNextRepairActNumber', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/repair/act-number?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getLatestServiceCarMileage = createAsyncThunk('appRepairActs/getLatestServiceCarMileage', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/repair/car-latest-mileage?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const changeRepairActClientDiscount = createAsyncThunk('appRepairActs/changeRepairActClientDiscount', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/repair/act-change-discount?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const getRepairActProfits = createAsyncThunk('appRepairActs/getRepairActProfits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/act-profits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// **
export const getServiceDefinitionActs = createAsyncThunk('appRepairActs/getServiceDefinitionActs', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1
    const response = await axios.post(`https://api.mfauto.com.ua/repair/get-service-acts?env=${process.env.REACT_APP_NODE_ENV}`, params)
    return {
        params,
        data: response.data.acts,
        totalPages: response.data.total_elements
    }
})

export const appRepairActsSlice = createSlice({
    name: 'appRepairActs',
    initialState: {
        acts: [],        
        total: 1,
        params: {},
        settings: [],
        selectedRepairAct: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getRepairActsList.fulfilled, (state, action) => {
            state.acts = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })       
        .addCase(getRepairAct.fulfilled, (state, action) => {
            state.selectedRepairAct = action.payload
        })  
        .addCase(getServiceDefinitionActs.fulfilled, (state, action) => {
            state.acts = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })    
    }
})

export default appRepairActsSlice.reducer
